import { useQuery } from '@tanstack/react-query'

import { api } from '../../../services/api'
import { ProvinceData } from '../../../types/interfaces'
import { queriesKeys } from '../queriesKeys'

export const useGetProvinceById = <T>(
  provinceId: number,
  select?: (data: ProvinceData) => T
) =>
  useQuery({
    enabled: !!provinceId,
    queryFn: () => api.provinces.getProvinceById(provinceId),
    queryKey: queriesKeys.provinces.getProvinceById(provinceId),
    select,
  })
